namespace h5_vm {
   export class DeviceOperationConstants {
      static readonly ADD: string = "add";
      static readonly EDIT: string = "edit";
      static readonly REMOVE: string = "remove";
   }
   angular
      .module("com.vmware.vsphere.client.vm")
      .constant("deviceOperationConstants", DeviceOperationConstants);
}